export default {
  label: 'Checkbox',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  hideLabel: false,
  disabled: false,
  validate: {
    required: true
  },
  defaultValue: {
    type: 'value',
    value: false
  },
  key: 'checkbox',
  type: 'checkbox',
  input: true,
  isNew: true
};
